/**
 * Shared helpers for social link formatting and validation (HYK-715, EditNetworks)
 */

export const formatSocialUrl = (platform, value) => {
  if (!value || (typeof value === "string" && value.trim() === "")) {
    return "";
  }
  let username = value;

  if (typeof value === "string" && value.includes("/")) {
    const cleanUrl = value.replace(/^(https?:\/\/)?(www\.)?/, "");

    switch (platform) {
      case "instagram":
        username = cleanUrl.replace(/^instagram\.com\//, "");
        break;
      case "twitter":
        username = cleanUrl.replace(/^(x\.com|twitter\.com)\//, "");
        break;
      case "facebook":
        username = cleanUrl.replace(/^facebook\.com\//, "");
        break;
      case "youtube":
        username = cleanUrl.replace(
          /^youtube\.com\/(@|channel\/|c\/|user\/)?/,
          ""
        );
        break;
      case "tiktok":
        username = cleanUrl.replace(/^tiktok\.com\/@?/, "");
        break;
      case "linkedin":
        username = cleanUrl.replace(/^linkedin\.com\/in\/?/, "");
        break;
      default:
        username = cleanUrl;
    }
  }

  username = (username || "").trim();
  if (!username) return "";

  switch (platform) {
    case "instagram":
      return `https://instagram.com/${username}`;
    case "twitter":
      return `https://x.com/${username}`;
    case "facebook":
      return `https://facebook.com/${username}`;
    case "youtube":
      if (
        username.startsWith("channel/") ||
        username.startsWith("c/") ||
        username.startsWith("user/")
      ) {
        return `https://youtube.com/${username}`;
      }
      return `https://youtube.com/@${username}`;
    case "tiktok":
      return `https://tiktok.com/@${username}`;
    case "linkedin":
      return `https://linkedin.com/in/${username}`;
    default:
      return username;
  }
};

export const validateSocialUrl = (platform, value) => {
  if (!value || value.trim() === "") return false;
  const patterns = {
    instagram: /^[a-zA-Z0-9._]+$/,
    twitter: /^[a-zA-Z0-9_]+$/,
    facebook: /^[a-zA-Z0-9.]+$/,
    youtube: /^[a-zA-Z0-9_-]+$/,
    tiktok: /^[a-zA-Z0-9._]+$/,
    linkedin: /^[a-zA-Z0-9-]+$/,
  };
  const pattern = patterns[platform];
  return pattern ? pattern.test(value.trim()) : false;
};

export const extractUsernameFromUrl = (platform, url) => {
  if (!url || url.trim() === "") return "";
  const formatted = formatSocialUrl(platform, url);
  switch (platform) {
    case "instagram":
      return formatted.replace(/^https:\/\/instagram\.com\//, "");
    case "twitter":
      return formatted.replace(/^https:\/\/x\.com\//, "");
    case "facebook":
      return formatted.replace(/^https:\/\/facebook\.com\//, "");
    case "youtube":
      return formatted.replace(
        /^https:\/\/youtube\.com\/(@|channel\/|c\/|user\/)?/,
        ""
      );
    case "tiktok":
      return formatted.replace(/^https:\/\/tiktok\.com\/@?/, "");
    case "linkedin":
      return formatted.replace(/^https:\/\/linkedin\.com\/in\//, "");
    default:
      return url;
  }
};
